// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-screen {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--bg-primary);
}

.login-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: 6px;
  padding: 40px 36px;
  width: 340px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.login-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 4px;
}

.login-logo-img {
  width: 56px;
  height: 56px;
  object-fit: contain;
  flex-shrink: 0;
}

.login-logo-text {
  font-size: 24px;
  font-weight: 600;
  color: var(--text-primary);
  letter-spacing: 0.02em;
}

.login-subtitle {
  color: var(--text-secondary);
  font-size: 12px;
  margin-bottom: 8px;
}

.login-form { display: flex; flex-direction: column; gap: 8px; }

.login-label {
  color: var(--text-secondary);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin-top: 4px;
}

.login-input {
  width: 100%;
  padding: 8px 10px;
  background: var(--bg-input);
  border: 1px solid var(--border);
  border-radius: 3px;
  color: var(--text-primary);
  font-size: 13px;
}
.login-input:focus { border-color: var(--accent-light); outline: none; }

.login-error { color: var(--red); font-size: 12px; margin-top: 2px; }

.login-submit {
  width: 100%;
  padding: 9px;
  margin-top: 8px;
  font-size: 13px;
  font-weight: 500;
}
.login-submit:disabled { opacity: 0.6; cursor: not-allowed; }
`, "",{"version":3,"sources":["webpack://./src/components/auth/Login.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;AACpB;;AAEA,cAAc,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;;AAE/D;EACE,4BAA4B;EAC5B,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,2BAA2B;EAC3B,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;AACjB;AACA,qBAAqB,iCAAiC,EAAE,aAAa,EAAE;;AAEvE,eAAe,iBAAiB,EAAE,eAAe,EAAE,eAAe,EAAE;;AAEpE;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;AACA,yBAAyB,YAAY,EAAE,mBAAmB,EAAE","sourcesContent":[".login-screen {\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--bg-primary);\n}\n\n.login-card {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: 6px;\n  padding: 40px 36px;\n  width: 340px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.login-logo {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 4px;\n}\n\n.login-logo-img {\n  width: 56px;\n  height: 56px;\n  object-fit: contain;\n  flex-shrink: 0;\n}\n\n.login-logo-text {\n  font-size: 24px;\n  font-weight: 600;\n  color: var(--text-primary);\n  letter-spacing: 0.02em;\n}\n\n.login-subtitle {\n  color: var(--text-secondary);\n  font-size: 12px;\n  margin-bottom: 8px;\n}\n\n.login-form { display: flex; flex-direction: column; gap: 8px; }\n\n.login-label {\n  color: var(--text-secondary);\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  margin-top: 4px;\n}\n\n.login-input {\n  width: 100%;\n  padding: 8px 10px;\n  background: var(--bg-input);\n  border: 1px solid var(--border);\n  border-radius: 3px;\n  color: var(--text-primary);\n  font-size: 13px;\n}\n.login-input:focus { border-color: var(--accent-light); outline: none; }\n\n.login-error { color: var(--red); font-size: 12px; margin-top: 2px; }\n\n.login-submit {\n  width: 100%;\n  padding: 9px;\n  margin-top: 8px;\n  font-size: 13px;\n  font-weight: 500;\n}\n.login-submit:disabled { opacity: 0.6; cursor: not-allowed; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
